import Promise from 'bluebird'
import estimatedProjectSpan from '../lib/calendars/estimated-project-span.js'

export default function (project) {
  return new Promise((resolve) => {
    const project_span = estimatedProjectSpan(project);
    resolve(project_span);
  });
};
